import React from 'react'
import dynamic from 'next/dynamic'
import { connect, useDispatch } from 'react-redux'
import { GtmList } from 'src/components/common/GoogleTagManager/'
import { Box, Grid, GridItem, Heading } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { OfferList } from 'src/components/common/StructuredData'
import { setListingPage } from 'src/redux/nlt-offer'

const Pagination = dynamic(() => import('src/components/Paginator/Pagination'))
const HomeOffersList = dynamic(() => import('src/components/NltOffers/HomeOffersList'))
const Offer = dynamic(() => import('src/components/NltOffers/Offer'))
const AutoPromo = dynamic(() => import('src/components/NltOffers/AutoPromo'))
const SuggestedFilters = dynamic(() => import('src/components/NltOffers/SuggestedFilters'))

const NltOffersContainer = ({ filterMenuIsOpen, offers, otherOffers, bgColor }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { items: offerItems } = offers

  const onPaginatorClickHandler = page => dispatch(setListingPage(page))

  return (
    <>
      <Grid
        templateColumns={{
          md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
          lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`,
        }}
        gap={6}
        pr="l"
        pt="l"
      >
        <GtmList
          items={offerItems.filter(offer => offer.code !== 'auto-promo')
            .map((offer: any) => (
              {
                name: offer.model,
                id: offer.code,
                monthlyRate: offer.monthlyRate,
                brand: offer.brand,
                category: offer.category,
                variant: offer.version
              }
            ))}
        />

        <SuggestedFilters
          colSpan={{
            md: filterMenuIsOpen ? 2 : 3,
            lg: filterMenuIsOpen ? 3 : 4
          }}
        />

        <OfferList
          items={
            offerItems.map(item => [
              'https://carplanner.com/noleggio-a-lungo-termine/',
              item.brandCode,
              '/',
              item.modelCode,
              '/',
              item.code,
              '?deposit=',
              item.deposit,
              '&contractLength=',
              item.contractLength,
              '&annualMileage=',
              item.annualMileage
            ].join(''))
          }
        />

        {offerItems.map((item: any) => {
          return item.code === 'auto-promo' ?
            (<GridItem key={`${item.code}- ${item.title} `} display="inline-grid">
              <AutoPromo item={item} />
            </GridItem>)
            :
            (<GridItem key={item.code} display="inline-grid">
              <Offer item={item} />
            </GridItem>)
        })
        }

        {offerItems.length ?
          <GridItem
            colSpan={{
              md: filterMenuIsOpen ? 2 : 3,
              lg: filterMenuIsOpen ? 3 : 4
            }}
            mt="-2"
            textAlign="left"
            key="load-more"
          >
            <Pagination
              currentPage={offers.currentPage}
              perPage={offers.pageSize}
              total={offers.results}
              onClick={onPaginatorClickHandler}
            />
          </GridItem>
          : null}
      </Grid>

      <Box
        display={offerItems.length ? 'none' : 'block'}
        float="right"
        pl={{ base: 'l', md: 'm' }}
        pr="l"
        w={{ base: '100%', md: '75%' }}
      >
        <Heading
          py="l"
          as="h3"
          fontSize="2xl"
          fontFamily="Montserrat-SemiBold"
        >
          {t('nltPage:notFound')}
        </Heading>
        <HomeOffersList
          action={t('indexPage:nlt_offers.action')}
          alt={t('indexPage:nlt_offers.alt')}
          bgColor={bgColor || 'baseNeutral.100'}
          href="/noleggio-a-lungo-termine"
          offers={otherOffers}
          numPerView={filterMenuIsOpen ? 3 : 4}
          pt="0"
        />
      </Box>
    </>
  )
}

const mapStateToProps = (state, ownProps?) => ({
  filterMenuIsOpen: state.nlt.filterMenuIsOpen,
  otherOffers: state.nlt.offers,
  offers: state.nlt.filteredOffers,
  ownProps
})

export default connect(mapStateToProps)(NltOffersContainer)
